// ADR 15.9.26ag §2 — one component, `aria-hidden` by default.
//
// `fill="currentColor"` is the whole colour story: an icon is the colour of
// the text beside it, so `text-accent` on the active nav item colours both,
// and no icon ever names a token of its own. An unknown `name` is a type
// error, not a blank square. The size union is deliberate — Material's icons
// are drawn at 24 and read at 20 beside text; anything else is a different
// asset.
//
// ADR 17.9.26f §3 — the size is emitted in `rem`, so the icon follows the
// root scale like every other length on the page (a unitless SVG attribute is
// CSS px and would not). `rem`, not `em`: an icon beside `text-sm` must still
// be 24 CSS px at 100%, and `em` would make it 21.

import { PATHS } from './paths'

const ROOT_PX = 16

export type IconName = keyof typeof PATHS

export interface IconProps {
  name: IconName
  size?: 20 | 24
  className?: string
  /** Only when the icon *is* the content; otherwise it is decorative and the caller labels. */
  label?: string
}

export function Icon({ name, size = 24, className = '', label }: IconProps) {
  const decorative = label === undefined
  const rem = `${size / ROOT_PX}rem`
  return (
    <svg
      viewBox="0 0 24 24"
      width={rem}
      height={rem}
      fill="currentColor"
      // `undefined`, not `false`: React renders `aria-hidden="false"`, which is noise.
      aria-hidden={decorative ? true : undefined}
      role={decorative ? undefined : 'img'}
      aria-label={label}
      className={className}
    >
      <path d={PATHS[name]} />
    </svg>
  )
}
